module.exports = __webpack_public_path__ + "img/homePageimg1.f894c6a2.png";